import Service from "../Service";
import AccountService from "./AccountService";
import UserService from "./UserService";

//const service = new Service();
const customerType = 'Health Professional';

export default class PatientService extends Service{

    constructor(cache){
        super(cache, 'Patients');
        let acc = new AccountService();
        if(cache)this.cache.storageId = 'Patients/' + acc.clinicId;
    }

    getById(clientId){
        return this.request('Patient/' + clientId);
    }

    save(user){
        let req = (user.clientId)? 'Patient/' + user.clientId : 'Patient';
        let options = {};
        let method = (user.clientId)? 'put':'post';
        options[method] = user;
        return this.request(req, options);
    }

    search(term){
        return this.request('Patient', {
            get:{
                term:term
            }
        });     
    }

    getAll(noCache){
        return this.request('Patient', {
            get:{
                term:''
            },
            noCache:noCache
        })

    }

    static GetById = UserService.GetById

    static Search(term){
        return UserService.Search(term).then((json) => {
            return json.filter(client => client.customerType != customerType);
        });
    }

    static Save = UserService.Save;

    static GetAll = UserService.GetAll;
}


// WEBPACK FOOTER //
// ./src/api/services/PatientService.js